import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';

//Import Components
import SectionTitle from "../../components/Shared/section-title";
import Pricing from "../../components/Shared/pricing-box";

class Price extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pricings : [
                { id : 1, title : "Test", price : "FREE", duration : "14 days", buttonText: "Buy Now", btnLink: "",
                    features : [
                        {title : "2 Weeks"},
                        {title : "Supports any number of MT4 demo accounts"},
                        {title : "Decords signals from any channel"},
                        {title : "Submits signals to MT4 from predefined channels (TTC_1, TTC_2 and TTC_3)"},
                    ]
                },
                { id : 2, title : "Demo", price : "40 USD", duration : "30 days", buttonText: "Get Started", btnLink: "", isActive : true,
                    features : [
                        {title : "1 Month"},
                        {title : "Supports any number of MT4 demo accounts"},
                        {title : "Decords signals from any channel"},
                        {title : "Submits signals to MT4 from any channel"},
                    ]
                },
                { id : 3, title : "Live", price : "200 USD", duration : "lifetime", buttonText: "Try It Now", btnLink: "",
                    features : [
                        {title : "Lifetime"},
                        {title : "Supports single MT4 live account and unlimited MT4 demo accounts"},
                        {title : "Decords signals from any channel"},
                        {title : "Submits signals to MT4 from any channel)"},
                    ]
                }
            ],
        }
    }
    
    render() {
        return (
            <React.Fragment>
                {/* <section className="section" id="pricing"> */}
                    <Container>
                        {/* section title */}
                        {/* <SectionTitle title="Charge your creative inspiration" desc=" that can provide everything you need to generate awareness, drive traffic, connect" /> */}

                        <Row id="pricing">
                            <Pricing pricings={this.state.pricings} />
                        </Row>
                    </Container>
                {/* </section> */}
            </React.Fragment>
        );
    }
}

export default Price;